
export class DateReq {
    date: string;

    constructor(date: string) {
        this.date = date;
    }
}